import React, { useMemo, useEffect, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { CSVLink } from "react-csv";


const ExportCsvButton = () => {
  const [organizationData, setOrganizationData] = useState(null);
  const [outcomeQ, setOutcomeQ] = useState(null);


  const get_auth = useSelector((state) => state.auth);
  const raw_data = useSelector(
    (state) => state.audit?.raw_data,
    shallowEqual
  );

  const core_data = useSelector((state) => state.audit?.core_data);
  const get_culture_audit_reports = useSelector(
    (state) => state.debrief_schedule?.culture_audit_reports
  );


  
  const get_organizations = useSelector((state) => state.organizations);
  const get_survey_questions = useSelector(
    (state) => state.surveyquestions
  );
  const get_employees = useSelector((state) => state.employees);

  const isAdmin = get_employees?.userEmp?.account_type === 5;

  useEffect(() => {
    if (get_organizations) {
      setOrganizationData(
        get_organizations[
          get_auth?.organization_id || get_organizations?.organization?.id
        ]
      );
    }
  }, [get_organizations]);

  useEffect(() => {
    if (organizationData) {
      const sortOrder = organizationData?.styling?.survey_sequence?.find(
        (item) => item.value === "outcome_question"
      )?.question?.sort_order;

      if (sortOrder) {
        const outcomeQ = get_survey_questions?.outcome_questions.find(
          (item) => item.sort_order === sortOrder
        );
        setOutcomeQ(outcomeQ);
      }
    }
  }, [organizationData, get_survey_questions]);

  const questionColumns = useMemo(() => {
    if (!core_data) return {};
    const columns = {};
    core_data?.questions?.dimensions?.forEach((dimension) => {
      dimension?.factors?.forEach((factor) => {
        factor?.questions?.forEach((question) => {
          if (question?.id && question?.q) {
            columns[question.id] = question.q;
          }
        });
      });
    });
    return columns;
  }, [core_data]);

  const binaryData = useMemo(() => {
    if (!core_data) return {};
    const columns = {};
    core_data?.questions?.dimensions?.forEach((dimension) => {
      dimension?.factors?.forEach((factor) => {
        factor?.questions?.forEach((question) => {
          if (question?.id && question?.q) {
            columns[question.id] = question?.binary;
          }
        });
      });
    });
    return columns;
  }, [core_data]);

  // Build a reverse mapping from overall ques_order (1..N) to question text
  const questionTextByOrder = useMemo(() => {
    if (!core_data?.questions?.dimensions) return {};
    const mapping = {};
    let overall = 1;
    core_data.questions.dimensions.forEach((dimension) => {
      dimension.factors.forEach((factor) => {
        factor.questions.forEach((question) => {
          // Use the English text from survey definition
          mapping[overall] = question.q;
          overall += 1;
        });
      });
    });
    return mapping;
  }, [core_data]);

  const emailByEmployeeId = useMemo(() => {
    const mapping = {};
    (get_employees?.employees || []).forEach((emp) => {
      if (emp?.id) {
        mapping[emp.id] = emp?.email || "";
      }
    });
    return mapping;
  }, [get_employees?.employees]);

  const lookUpCategory = (cat) => {
    if (!core_data) return "";
    if (cat.priority === "primary") {
      const categoryOptions = core_data.categories[0].categories?.find(
        (item) => item.id === cat.id
      )?.options;

      if ("subfactors" in categoryOptions[0]) {
        const subfactorOptions = categoryOptions?.find(
          (item) => item.id === cat.response
        )?.subfactors;
        return (
          subfactorOptions?.find((item) => item.id === cat.subfactor)?.name || ""
        );
      }
      return (
        categoryOptions?.find((item) => item.id === cat.response)?.name || ""
      );
    }

    if (!cat.response) {
      return "";
    }

    const categoryOptions = core_data.categories[0].categories?.find(
      (item) => item.id === cat.id
    )?.options;
    return (
      categoryOptions?.find((item) => item.id === cat.response)?.name || ""
    );
  };

  function sanitizeForCSV(value) {
    if (typeof value === "string") {
      // Convert any existing " into "" (this is the standard CSV escape)
      // Optionally you could also handle newlines or other characters if needed
      return value.replace(/"/g, '""');
    }
    return value;
  }

  const hashString = async (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  };

  const csvData = useMemo(() => {
    if (!raw_data || !core_data) return [];

    const categoryOrder = core_data.categories?.[0]?.categories || [];

    const firstResponses = Array.isArray(raw_data)
      ? raw_data?.[0]?.responses
      : raw_data?.responses;

    if (!Array.isArray(firstResponses)) return [];

    return firstResponses.map((item) => {
      // Build categories in a stable order based on core_data categories
      const categories = {};
      categoryOrder.forEach((coreCat, index) => {
        const matchedCat = item?.categories?.find?.((c) => c.id === coreCat.id);
        categories[`Category ${index + 1}`] = matchedCat ? lookUpCategory(matchedCat) : "";
      });

      const scores = {};
      // let isChampion = false;
      // item.questions.forEach((q) => {
      //   const questionText = questionColumns[q.ques_order];
      //   if (questionText) {
      //     scores[questionText] = q.response;
      //     if (binaryData[q.ques_order]) {
      //       isChampion = true;
      //     }
      //   }
      // });

      let isChampion = false;
      if (Array.isArray(item.questions)) {
        item.questions.forEach((q) => {
          const questionText = questionTextByOrder[q.ques_order];
          if (questionText) {
            scores[questionText] = q.response;
          }
        });
      }
        

      if (isChampion) {
        console.log("Champion", item.employee);
      }

      const outcomes = {};
      if (item.employee_outcomes) {
        outcomeQ?.questions?.forEach((q) => {
          q?.questions?.forEach((question) => {
              const outcome = item.employee_outcomes?.responses.find((r) => parseInt(r.s) === parseInt(question.s) && parseInt(r.q) === parseInt(question.q));
              outcomes[question.question] = outcome?.response
          
      } );
      } );
      }

      const comments = {};
      if(item?.comments){
        item.comments.forEach((comment,i) => {
          const comment_q = core_data.questions.comments?.find((q,idx) => idx == i)?.question;
          comments[comment_q] = sanitizeForCSV(comment.feedback)
        });
      }



      const employee_id = item.employee;
      const memberEmail = emailByEmployeeId?.[employee_id] || "";
      const categories_in_org = core_data.orgCategories?.find((f) => f.employee == employee_id);

      if (isChampion) {
        console.log("Champion", item.employee, categories_in_org);
      }

      console.log(comments)


      return {
        "Member Email": memberEmail,
        ...categories,
        ...scores,
        ...outcomes,
        ...comments,
      };
    });
  }, [raw_data, questionColumns, core_data, outcomeQ, binaryData, emailByEmployeeId]);

  const headers = useMemo(() => {
    if (csvData.length === 0) return [];
    const allKeys = Object.keys(csvData[0]);
    return allKeys.map((key) => ({
      label: key,
      key: key,
    }));
  }, [csvData]);

  if (!core_data || !raw_data) {
    return <div>Loading data...</div>;
  }

  if (!isAdmin) {
    return <div>Access restricted.</div>;
  }

  // Helper to build CSV for a single survey response (same shape as latest)
  const buildCsvFromSurvey = (survey) => {
    if (!survey || !core_data) return [];
    const categoryOrder = core_data.categories?.[0]?.categories || [];
    return (survey.responses || []).map((sub) => {
      const resp = sub?.response || {};
      const employeeId = sub?.employee || resp?.employee || sub?.employee_id || resp?.employee_id;
      const memberEmail = employeeId ? (emailByEmployeeId?.[employeeId] || "") : "";

      const categories = {};
      categoryOrder.forEach((coreCat, index) => {
        const matchedCat = resp.categories?.find((c) => c.id === coreCat.id);
        categories[`Category ${index + 1}`] = matchedCat ? lookUpCategory(matchedCat) : "";
      });

      const scores = {};
      if (Array.isArray(resp.questions)) {
        resp.questions.forEach((rq) => {
          // Prefer ques_order alignment to definition order for consistent text mapping
          const questionText = questionTextByOrder[rq.ques_order];
          if (questionText) {
            scores[questionText] = rq.response;
            return;
          }
          // Fallback: dimension/factor/local id mapping
          const dim = core_data?.questions?.dimensions?.find((d) => parseInt(d.id) === parseInt(rq.id));
          const fac = dim?.factors?.find((f) => parseInt(f.id) === parseInt(rq.factor));
          const quesDef = fac?.questions?.find((q) => parseInt(q.id) === parseInt(rq.q));
          if (quesDef?.q) {
            scores[quesDef.q] = rq.response;
          }
        });
      }

      const outcomes = {};
      if (resp.employee_outcomes) {
        outcomeQ?.questions?.forEach((q) => {
          q?.questions?.forEach((question) => {
            const outcome = resp.employee_outcomes?.responses?.find((r) => parseInt(r.s) === parseInt(question.s) && parseInt(r.q) === parseInt(question.q));
            outcomes[question.question] = outcome?.response;
          });
        });
      }

      const comments = {};
      if (resp.comments) {
        resp.comments.forEach((comment, i) => {
          const comment_q = core_data.questions.comments.find((q, idx) => idx == i)?.question;
          comments[comment_q] = sanitizeForCSV(comment.feedback);
        });
      }

      return {
        "Member Email": memberEmail,
        ...categories,
        ...scores,
        ...outcomes,
        ...comments,
      };
    });
  };

  const buildHeaders = (data) => {
    if (!data || data.length === 0) return [];
    const allKeys = Object.keys(data[0]);
    return allKeys.map((key) => ({ label: key, key }));
  };

  const surveyList = get_culture_audit_reports?.response || [];

  return (
    <div style={{ marginTop: 30 }}>
      <CSVLink
        data={csvData}
        headers={headers}
        filename="raw_scores.csv"
        separator=","
        enclosingCharacter={'"'}
      >
        <button>Download latest CSV</button>
      </CSVLink>

      {/* Table of individual survey responses with CSV downloads */}
      <div style={{ marginTop: 20 }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Name</th>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Date</th>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Version</th>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Responses</th>
              <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: "8px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {surveyList.map((survey, idx) => {
              const data = buildCsvFromSurvey(survey);
              const hdrs = buildHeaders(data);
              const dateString = survey?.date || survey?.created_at || "";
              const version = survey?.question?.sort_order || "";
              const count = survey?.responses?.length || 0;
              const name = survey?.name || survey?.report_name || survey?.question?.title || survey?.question?.questions?.title || survey?.type || `Response ${survey?.id || idx}`;
              return (
                <tr key={survey?.id || idx}>
                  <td style={{ borderBottom: "1px solid #f0f0f0", padding: "8px" }}>{name}</td>
                  <td style={{ borderBottom: "1px solid #f0f0f0", padding: "8px" }}>{dateString}</td>
                  <td style={{ borderBottom: "1px solid #f0f0f0", padding: "8px" }}>{version}</td>
                  <td style={{ borderBottom: "1px solid #f0f0f0", padding: "8px" }}>{count}</td>
                  <td style={{ borderBottom: "1px solid #f0f0f0", padding: "8px" }}>
                    {data && data.length > 0 ? (
                      <CSVLink
                        data={data}
                        headers={hdrs}
                        filename={`raw_scores_${survey?.id || idx}.csv`}
                        separator="," 
                        enclosingCharacter={'"'}
                      >
                        <button>Download CSV</button>
                      </CSVLink>
                    ) : (
                      <span style={{ color: "#888" }}>No data</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExportCsvButton;
